<button type="button" class="sg-sport cursor" [ngClass]="{'sg-sport--active': active}">
    <mlp-ng-icon class="sg-sport__icon-action" [ngClass]="{'-active': active}" [name]="faIcon"></mlp-ng-icon>
    <figure class="sg-sport__figure">
        <mlp-ng-icon class="sg-sport__icon" [name]="sport.id"></mlp-ng-icon>
        <figcaption>{{ sport.attributes.name }}</figcaption>
    </figure>
</button>